export const getPolygonCenter = (coords: google.maps.LatLngLiteral[]) => {
  const polygon = new window.google.maps.Polygon({ paths: coords });
  const bounds = new window.google.maps.LatLngBounds();
  coords.forEach((c) => bounds.extend(c));

  const steps = 10;
  const latStep = (bounds.getNorthEast().lat() - bounds.getSouthWest().lat()) / steps;
  const lngStep = (bounds.getNorthEast().lng() - bounds.getSouthWest().lng()) / steps;

  let bestPoint = null;
  let minDistanceToCenter = Infinity;

  const centerLat = (bounds.getNorthEast().lat() + bounds.getSouthWest().lat()) / 2;
  const centerLng = (bounds.getNorthEast().lng() + bounds.getSouthWest().lng()) / 2;

  for (let i = 0; i <= steps; i++) {
    for (let j = 0; j <= steps; j++) {
      const point = new google.maps.LatLng(
        bounds.getSouthWest().lat() + i * latStep,
        bounds.getSouthWest().lng() + j * lngStep
      );

      if (window.google.maps.geometry.poly.containsLocation(point, polygon)) {
        const dist = Math.hypot(point.lat() - centerLat, point.lng() - centerLng);
        if (dist < minDistanceToCenter) {
          minDistanceToCenter = dist;
          bestPoint = point;
        }
      }
    }
  }

  if (bestPoint) return { lat: bestPoint.lat(), lng: bestPoint.lng() };

  const fallbackCenter = bounds.getCenter();
  return { lat: fallbackCenter.lat(), lng: fallbackCenter.lng() };
};